import { farol } from '../farol'

import type { Taxa } from '../types'
import type { ExplicacaoProps } from '@/features/relatorio/components/explicacao'
import type { ReactElement } from 'react'

import { KpiCard } from '@/features/relatorio/components/kpi-card'
import { percentual } from '@/lib/formato'

export interface TaxaCardProps {
  rotulo: string
  taxa: Taxa
  /** Alvo do indicador (0..1) — base do farol. */
  meta: number
  cadencia?: string
  explicacao: Omit<ExplicacaoProps, 'rotulo'>
  /** Texto do denominador (ex.: "entregas com prazo"). */
  unidade: string
  tamanho?: 'normal' | 'telao'
}

/**
 * Card de um indicador de taxa. O ponto central é `taxa === null`: significa que
 * a janela não tem denominador — cadência não registrada — e NÃO 0% de
 * desempenho. Mostrar "0%" aqui acusaria a operação de uma falha que é de
 * preenchimento, então o card troca o número por um aviso explícito.
 */
export function TaxaCard({
  rotulo,
  taxa,
  meta,
  cadencia,
  explicacao,
  unidade,
  tamanho,
}: TaxaCardProps): ReactElement {
  // `valor` local em vez de `taxa.taxa`: o narrowing sobrevive, dispensando os
  // `?? 0` que seriam ramos inalcançáveis (e descobertos no gate de 100%).
  const valor = taxa.taxa

  return (
    <KpiCard
      rotulo={rotulo}
      valor={valor === null ? '—' : percentual(valor, 0)}
      cadencia={cadencia}
      rag={farol(valor, meta)}
      progresso={valor ?? undefined}
      origem="clickup"
      detalhe={
        valor === null
          ? 'Sem registro na janela — nenhuma tarefa com prazo'
          : `${taxa.noPrazo} de ${taxa.total} ${unidade}`
      }
      explicacao={explicacao}
      tamanho={tamanho}
    />
  )
}
